import { Dispatch } from "../../store/types";
import { actions as step1Actions } from "../Step1";
import { actions as styleActions } from "../WizardStyleChoice";
import { actions as layoutActions } from "../WizardLayoutChoice";
import { actions as colorActions } from "../WizardColorChoice";
import { actions as step4Actions } from "../Step4";
import { actions as step5Actions } from "../Step5";
import { actions as summaryActions } from "../WizardSummary";

/**
 * Thunk used for when the chosen product changes; resets all post-step1 persistent wizard choices.
 */
export const resetProductChoices = () => (dispatch: Dispatch) => {
  dispatch(styleActions.reset());
  dispatch(layoutActions.reset());
  dispatch(colorActions.reset());
  dispatch(step4Actions.reset());
  dispatch(step5Actions.reset());
  dispatch(summaryActions.reset());
};

/**
 * Thunk used for resetting the entire persistent wizard step choices.
 */
export const resetWizard = () => (dispatch: Dispatch) => {
  dispatch(step1Actions.reset());
  dispatch(resetProductChoices());
};



// WEBPACK FOOTER //
// ./src/routes/Wizard/actions.ts